import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setFormData,
  setFormStructure,
  setStep,
  removeFormField,
} from "../../../Redux/formSlice";
import "./reviewForm.css";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Spin,
  Row,
  Col,
} from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { base64ToFile, decryptObject } from "../../GlobalFunction";
import {
  ClientDropdownData,
  getAcountOwnerList,
  getClientCustomerList,
  SubmitForm,
} from "../../../services/ApiService";
import { DeleteOutlined } from "@ant-design/icons";
import { FaCalendarAlt } from "react-icons/fa";
import { NumericFormat } from "react-number-format";
const { Option } = Select;

const EE_CLIENT_CHARGES_FIELDS = [
  { name: "ee_client_deposit", label: "Deposit", type: "number" },
  { name: "ee_client_setup_fees", label: "Setup Fees", type: "number" },
  { name: "ee_client_termination_fees", label: "Termination Fees", type: "number" },
  { name: "ee_client_monthly_minimum_fees_locals", label: "Monthly Minimum Fees (Locals)", type: "number" },
  { name: "ee_client_monthly_minimum_fees_expats", label: "Monthly Minimum Fees (Expats)", type: "number" },
  { name: "ee_client_monthly_percentage", label: "Monthly Percentage", type: "number" },
  { name: "ee_client_year_end_charges", label: "Year End Charges", type: "number" },
  { name: "ee_client_off_cycle_fees", label: "Off Cycle Fees", type: "number" },
  { name: "ee_client_it_procurement_charges", label: "IT Procurement Charges", type: "number" },
  { name: "ee_client_adhoc_service_description", label: "Adhoc Service Description", type: "textarea" },
  { name: "ee_visa_sponsorship", label: "Visa Sponsorship", type: "text" },
  { name: "ee_client_adhoc_service_charges", label: "Adhoc Service Charges", type: "number" },
];

const OnboardForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [form] = Form.useForm();
  const formData = useSelector((state) => state.form.formData);
  const formStructure = useSelector((state) => state.form.formStructure);
  const sessionData = decryptObject(sessionStorage.getItem("sessioninfo"));
  const [clientList, setClientList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [isOthersSelected, setIsOthersSelected] = useState(false);
  const [sameAsCurrent, setSameAsCurrent] = useState(false);

  if (!formStructure || Object.keys(formStructure).length === 0) {
    navigate("/masterDatabase");
  }

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        setloading(true);

        const [ownerRes, clientRes] = await Promise.all([
          getAcountOwnerList(),
          ClientDropdownData(),
        ]);

        let accountOwnerOptions = [];
        let clientOptions = [];

        if (ownerRes?.responseCode === 200) {
          accountOwnerOptions = ownerRes?.res?.map((owner) => ({
            label: owner.name,
            value: owner.id,
          }));
        }

        if (clientRes) {
          setClientList(clientRes?.client);
          clientOptions = clientRes?.client?.map((cl) => ({
            label: cl.client_name,
            value: cl.client_id,
          }));
        }

        const updatedStructure = JSON.parse(JSON.stringify(formStructure));

        Object.keys(updatedStructure).forEach((stepKey) => {
          updatedStructure[stepKey].forEach((section) => {
            Object.values(section).forEach((fields) => {
              fields.forEach((field) => {
                if (field.id === 69) {
                  field.option = accountOwnerOptions;
                }
                if (field.id === 1) {
                  field.option = clientOptions;
                }
              });
            });
          });
        });

        dispatch(setFormStructure(updatedStructure));
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
      } finally {
        setloading(false);
      }
    };

    fetchDropdownData();
  }, []);

  const countryCurrencyMap = [
    "Afghanistan-AFN",
    "Albania-ALL",
    "Algeria-DZD",
    "Andorra-EUR",
    "Angola-AOA",
    "Antigua and Barbuda-XCD",
    "Argentina-ARS",
    "Armenia-AMD",
    "Australia-AUD",
    "Austria-EUR",
    "Azerbaijan-AZN",
    "Bahamas-BSD",
    "Bahrain-BHD",
    "Bangladesh-BDT",
    "Barbados-BBD",
    "Belarus-BYN",
    "Belgium-EUR",
    "Belize-BZD",
    "Benin-XOF",
    "Bhutan-BTN",
    "Bolivia-BOB",
    "Bosnia and Herzegovina-BAM",
    "Botswana-BWP",
    "Brazil-BRL",
    "Brunei-BND",
    "Bulgaria-BGN",
    "Burkina Faso-XOF",
    "Burundi-BIF",
    "Cabo Verde-CVE",
    "Cambodia-KHR",
    "Cameroon-XAF",
    "Canada-CAD",
    "Central African Republic-XAF",
    "Chad-XAF",
    "Chile-CLP",
    "China-CNY",
    "Colombia-COP",
    "Comoros-KMF",
    "Congo (Congo-Brazzaville)-XAF",
    "Costa Rica-CRC",
    "Croatia-EUR",
    "Cuba-CUP",
    "Cyprus-EUR",
    "Czech Republic-CZK",
    "Democratic Republic of the Congo-CDF",
    "Denmark-DKK",
    "Djibouti-DJF",
    "Dominica-XCD",
    "Dominican Republic-DOP",
    "Ecuador-USD",
    "Egypt-EGP",
    "El Salvador-USD",
    "Equatorial Guinea-XAF",
    "Eritrea-ERN",
    "Estonia-EUR",
    "Eswatini-SZL",
    "Ethiopia-ETB",
    "Fiji-FJD",
    "Finland-EUR",
    "France-EUR",
    "Gabon-XAF",
    "Gambia-GMD",
    "Georgia-GEL",
    "Germany-EUR",
    "Ghana-GHS",
    "Greece-EUR",
    "Grenada-XCD",
    "Guatemala-GTQ",
    "Guinea-GNF",
    "Guinea-Bissau-XOF",
    "Guyana-GYD",
    "Haiti-HTG",
    "Honduras-HNL",
    "Hungary-HUF",
    "Iceland-ISK",
    "India-INR",
    "Indonesia-IDR",
    "Iran-IRR",
    "Iraq-IQD",
    "Ireland-EUR",
    "Israel-ILS",
    "Italy-EUR",
    "Jamaica-JMD",
    "Japan-JPY",
    "Jordan-JOD",
    "Kazakhstan-KZT",
    "Kenya-KES",
    "Kiribati-AUD",
    "Kuwait-KWD",
    "Kyrgyzstan-KGS",
    "Laos-LAK",
    "Latvia-EUR",
    "Lebanon-LBP",
    "Lesotho-LSL",
    "Liberia-LRD",
    "Libya-LYD",
    "Liechtenstein-CHF",
    "Lithuania-EUR",
    "Luxembourg-EUR",
    "Madagascar-MGA",
    "Malawi-MWK",
    "Malaysia-MYR",
    "Maldives-MVR",
    "Mali-XOF",
    "Malta-EUR",
    "Marshall Islands-USD",
    "Mauritania-MRU",
    "Mauritius-MUR",
    "Mexico-MXN",
    "Micronesia-USD",
    "Moldova-MDL",
    "Monaco-EUR",
    "Mongolia-MNT",
    "Montenegro-EUR",
    "Morocco-MAD",
    "Mozambique-MZN",
    "Myanmar-MMK",
    "Namibia-NAD",
    "Nauru-AUD",
    "Nepal-NPR",
    "Netherlands-EUR",
    "New Zealand-NZD",
    "Nicaragua-NIO",
    "Niger-XOF",
    "Nigeria-NGN",
    "North Korea-KPW",
    "North Macedonia-MKD",
    "Norway-NOK",
    "Oman-OMR",
    "Pakistan-PKR",
    "Palau-USD",
    "Palestine State-ILS",
    "Panama-PAB",
    "Papua New Guinea-PGK",
    "Paraguay-PYG",
    "Peru-PEN",
    "Philippines-PHP",
    "Poland-PLN",
    "Portugal-EUR",
    "Qatar-QAR",
    "Romania-RON",
    "Russia-RUB",
    "Rwanda-RWF",
    "Saint Kitts and Nevis-XCD",
    "Saint Lucia-XCD",
    "Saint Vincent and the Grenadines-XCD",
    "Samoa-WST",
    "San Marino-EUR",
    "Sao Tome and Principe-STN",
    "Saudi Arabia-SAR",
    "Senegal-XOF",
    "Serbia-RSD",
    "Seychelles-SCR",
    "Sierra Leone-SLL",
    "Singapore-SGD",
    "Slovakia-EUR",
    "Slovenia-EUR",
    "Solomon Islands-SBD",
    "Somalia-SOS",
    "South Africa-ZAR",
    "South Korea-KRW",
    "South Sudan-SSP",
    "Spain-EUR",
    "Sri Lanka-LKR",
    "Sudan-SDG",
    "Suriname-SRD",
    "Sweden-SEK",
    "Switzerland-CHF",
    "Syria-SYP",
    "Taiwan-TWD",
    "Tajikistan-TJS",
    "Tanzania-TZS",
    "Thailand-THB",
    "Timor-Leste-USD",
    "Togo-XOF",
    "Tonga-TOP",
    "Trinidad and Tobago-TTD",
    "Tunisia-TND",
    "Turkey-TRY",
    "Turkmenistan-TMT",
    "Tuvalu-AUD",
    "Uganda-UGX",
    "Ukraine-UAH",
    "United Arab Emirates-AED",
    "United Kingdom-GBP",
    "United States of America-USD",
    "Uruguay-UYU",
    "Uzbekistan-UZS",
    "Vanuatu-VUV",
    "Vatican City-EUR",
    "Venezuela-VES",
    "Vietnam-VND",
    "Yemen-YER",
    "Zambia-ZMW",
    "Zimbabwe-ZWL",
  ];

  const setFieldData = (payload) => {
    dispatch(setFormData(payload));
  };

  const checkRequiredFields = (formStructureData) => {
    let isValid = true;

    // Recursive function to validate a field and its conditional fields
    const validateField = (field) => {
      const value = formData[field.id];

      // Check if current field is required
      if (field.required && (value === undefined || value === "")) {
        isValid = false;
      }

      // If current field has conditional_fields based on its value
      if (
        field.conditional_fields &&
        value &&
        field.conditional_fields[value]
      ) {
        const conditionalFields = field.conditional_fields[value];
        conditionalFields.forEach((cf) => {
          validateField(cf); // 🔁 recursive call
        });
      }
    };

    Object.keys(formStructureData).forEach((stepKey) => {
      const stepData = formStructureData[stepKey];

      if (!Array.isArray(stepData)) return;

      stepData.forEach((section) => {
        Object.values(section).forEach((fields) => {
          fields.forEach((field) => {
            validateField(field); // Start validation from each field
          });
        });
      });
    });

    return isValid;
  };

  const countryCurrencyObject = {};
  countryCurrencyMap.forEach((entry) => {
    const [country, currency] = entry.split("-");
    countryCurrencyObject[country.trim()] = currency.trim();
  });

  function getCurrencyByCountry(countryName) {
    if (!countryName) return "";
    return countryCurrencyObject[countryName.trim()] || "Currency not found";
  }

  const OTHER_COUNTRY_VALUE = "Other";

  const allCountryOptions = countryCurrencyMap.map((entry) =>
    entry.split("-")[0].trim()
  );

  const setFieldOptions = (fieldId, options) => {
    const updatedStructure = JSON.parse(JSON.stringify(formStructure));

    Object.keys(updatedStructure).forEach((stepKey) => {
      updatedStructure[stepKey].forEach((section) => {
        Object.values(section).forEach((fields) => {
          fields.forEach((field) => {
            if (field.id === fieldId) {
              field.option = options;
            }
          });
        });
      });
    });

    dispatch(setFormStructure(updatedStructure));
  };

  const sanitizeFormData = (data) => {
    const updatedData = { ...data };
    // if (!updatedData["11"]) updatedData["11"] = "Local"; // Resident Status
    // if (!updatedData["16"]) updatedData["16"] = "Others"; // Gender
    // if (!updatedData["26"]) updatedData["26"] = "Indefinite"; // Type of Employment
    if (!updatedData["62"]) updatedData["62"] = "Annually"; // Salary Type
    // if (!updatedData["36"]) updatedData["36"] = "No"; // Health Insurance
    if (!updatedData["40"]) updatedData["40"] = "No"; // Term Life Insurance
    if (!updatedData["78"]) updatedData["78"] = "No"; // Personal Accidental Insurance

    // Condition 1: Resident Status == Local
    if (updatedData["11"] === "Local") {
      if (updatedData["67"]) updatedData["10"] = updatedData["67"]; // Nationality = Country of Employment
      updatedData["12"] = ""; // Type of Visa
      updatedData["14"] = ""; // Visa Expiry
      updatedData["15"] = ""; // DOB
    }

    // Condition 2: Type of Employment ≠ Fixed
    // if (updatedData["26"] !== "Fixed") {
    //   updatedData["29"] = ""; // End Date of Employment
    // }

    // Condition 4: Health Insurance == No
    if (updatedData["36"] === "No") {
      updatedData["37"] = ""; // HI Coverage
      updatedData["74"] = ""; // Billing
      updatedData["76"] = ""; // Comments
    } else {
      // Billing default only when HI is Yes and billing is not set
      // if (!updatedData["74"]) {
      //   updatedData["74"] = "Client Paid";
      // }
    }

    // Condition 5: Billing Details ≠ Partial
    if (updatedData["74"] !== "Partial") {
      updatedData["76"] = ""; // Clear HI Comments
    }

    // Condition 6: Term Life Insurance ≠ Yes
    if (updatedData["40"] !== "Yes") {
      updatedData["41"] = ""; // Term Life Coverage
    }

    // Condition 7: Personal Accidental Insurance ≠ Yes
    if (updatedData["78"] !== "Yes") {
      updatedData["79"] = ""; // Accident Coverage
    }

    if (!updatedData["69"]) {
      updatedData["69"] = sessionData.employee_id;
    }

    return updatedData;
  };

  const handleFormChange = async (value, name) => {
    setFieldData({ name, value });
    form.setFieldsValue({ [name]: value });
    // Condition: Auto-set currency from nationality (country)

    // Sync field 137 (Permanent Address) if checkbox is active
    if (sameAsCurrent && name === 138) {
      handleFormChange(value, 137);
    }

    if (name === 67 && value === OTHER_COUNTRY_VALUE) {
      setFieldData({ name: "67", value: "" });
      form.setFieldsValue({ 67: "" });
      setFieldOptions(67, allCountryOptions);
    } else if (name === 67) {
      const currency = value ? getCurrencyByCountry(value) : "";
      if (currency || !value) {
        setFieldData({ name: "31", value: currency });
        form.setFieldsValue({ 31: currency });
      }
    }

    // Condition 1: Resident Status = Local
    if (name === 11 && value === "Local") {
      const nationality = formData["67"];
      if (nationality) {
        setFieldData({ name: "10", value: nationality });
        form.setFieldsValue({ 10: nationality });
      }

      setFieldData({ name: "12", value: "" });
      setFieldData({ name: "14", value: "" });
      setFieldData({ name: "15", value: "" });
      form.setFieldsValue({
        12: "",
        14: "",
        15: "",
      });
    }

    // Condition 2: Type of Employment not Fixed
    if (name === 26 && value !== "Fixed") {
      setFieldData({ name: "29", value: "" });
      form.setFieldsValue({
        29: "",
      });
    }
    // Condition 4: Health Insurance = No
    if (name === 36 && value === "No") {
      setFieldData({ name: "37", value: "" });
      setFieldData({ name: "74", value: "" });
      setFieldData({ name: "76", value: "" });
      form.setFieldsValue({
        37: "",
        74: "",
        76: "",
      });
    }

    // Condition 5: Billing Details ≠ Partial
    if (name === 74 && value !== "Partial") {
      setFieldData({ name: "76", value: "" });
      form.setFieldsValue({
        76: "",
      });
    }

    // Condition 6: Term Life Insurance ≠ Yes
    if (name === 40 && value !== "Yes") {
      setFieldData({ name: "41", value: "" });
      form.setFieldsValue({
        41: "",
      });
    }

    // Condition 7: Accidental Insurance ≠ Yes
    if (name === 78 && value !== "Yes") {
      setFieldData({ name: "79", value: "" });
      form.setFieldsValue({
        79: "",
      });
    }

    if (name === 26) {
      const updatedStructure = JSON.parse(JSON.stringify(formStructure));

      Object.keys(updatedStructure).forEach((stepKey) => {
        updatedStructure[stepKey].forEach((section) => {
          Object.values(section).forEach((fields) => {
            fields.forEach((field) => {
              if (field.id === 29) {
                field.required = value === "Fixed";
              }
            });
          });
        });
      });

      dispatch(setFormStructure(updatedStructure));
    }

    if (name === 1) {
      const clientObj = value
        ? clientList.find((item) => item.client_id == value)
        : null;

      if (!clientObj) {
        setFieldData({ name: "63", value: "" });
        setFieldData({ name: "4", value: "" });
        setFieldData({ name: "5", value: "" });
        setFieldData({ name: "65", value: "" });
        setFieldData({ name: "64", value: "" });
        setFieldData({ name: "67", value: "" });

        form.setFieldsValue({
          63: "",
          4: "",
          5: "",
          65: "",
          64: "",
          67: "",
        });

        setCustomerList([]);
        setFieldOptions(64, []);
        setIsOthersSelected(false);
        return;
      }

      setFieldData({ name: "63", value: clientObj.client_billing_entity });
      setFieldData({ name: "4", value: clientObj.client_contact_person_name });
      setFieldData({
        name: "5",
        value: clientObj.client_contact_email_address,
      });
      setFieldData({ name: "65", value: clientObj.client_contact_phone });
      setFieldData({ name: "64", value: "" });
      setFieldData({ name: "67", value: "" });

      form.setFieldsValue({
        63: clientObj.client_billing_entity,
        4: clientObj.client_contact_person_name,
        5: clientObj.client_contact_email_address,
        65: clientObj.client_contact_phone,
        64: "",
        67: "",
      });

      try {
        setloading(true);
        const res = await getClientCustomerList(value);

        if (res?.responseCode === 200) {
          let customers = res?.data || [];
          setCustomerList(customers);
          // Convert to dropdown structure
          let customerOptions = customers.map((c) => ({
            label: c.client_customer_name,
            value: c.client_customer_id,
          }));

          // Clone and update formStructure
          const updatedStructure = JSON.parse(JSON.stringify(formStructure));

          Object.keys(updatedStructure).forEach((stepKey) => {
            updatedStructure[stepKey].forEach((section) => {
              Object.values(section).forEach((fields) => {
                fields.forEach((field) => {
                  if (field.id === 64) {
                    field.option = customerOptions;
                  }
                });
              });
            });
          });

          dispatch(setFormStructure(updatedStructure));
        }
      } catch (error) {
        console.error("Failed to load customer list", error);
      } finally {
        setloading(false);
        setIsOthersSelected(false);
      }
    }

    if (name === 64) {
      setFieldData({ name: "67", value: "" });
      form.setFieldsValue({ 67: "" });

      // Country of Employment options come straight from the countries
      // this customer (across every underlying country-specific row) is
      // already associated with -- confirmed with the user, 2026-10-27 --
      // instead of the old per-row historical-employee-only lookup,
      // which missed countries with no onboarded employees yet.
      const selectedCustomer = customerList.find((c) => c.client_customer_id === value);
      const countryOptions = [
        ...(selectedCustomer?.countries || []),
        OTHER_COUNTRY_VALUE,
      ];
      setFieldOptions(67, countryOptions);
    }
  };

  const handleSubmit = async () => {
    const allFieldsFilled = checkRequiredFields(formStructure);

    if (!allFieldsFilled) {
      message.error("Please fill all required fields before submitting.");
      return;
    }

    try {
      setloading(true);
      const sanitizedForm = sanitizeFormData(formData);
      const formDatatry = new FormData();

      Object.entries(sanitizedForm).forEach(([key, value]) => {
        if (value && typeof value === "object" && value?.data) {
          const newvalue = base64ToFile(value?.data, value?.name, value?.type);
          formDatatry.append(`${key}`, newvalue);
        } else {
          formDatatry.append(key, value);
        }
      });

      let res;

      res = await SubmitForm(formDatatry);
      if (res?.responseCode === 200) {
        message.success(res.responseMessage);
        navigate("/masterDatabase");
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong. Please try again.");
    } finally {
      setloading(false);
    }
  };

  function formatDate(date) {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  }

  const handleDateChange = (value, name) => {
    const formattedDate = value ? formatDate(value) : "";
    setFieldData({ name, value: formattedDate });
  };

  const handleSave = async () => {
    Modal.confirm({
      title: "Are you sure?",
      content:
        "If you save the details, your request will be shown in the Directory.",
      okText: "Yes, Submit!",
      okType: "danger",
      cancelText: "Cancel",
      centered: true,
      onOk: () => handleSubmit(),
    });
  };

  const renderField = (fieldId, fieldData) => {
    const value = formData[fieldId];
    const rules = [];

    if (fieldData.required) {
      rules.push({ required: true, message: `${fieldData.label} is required` });
    }

    if (fieldData.input_type === "number") {
      rules.push({
        pattern: /^[0-9+\- ]+$/,
        message: "Only numbers, '+', '-' and spaces are allowed",
      });
    }

    if (fieldData.input_type === "alphabet") {
      rules.push({
        pattern: /^[A-Za-z\s]+$/,
        message: "Only alphabets are allowed",
      });
    }

    if (fieldId === 64) {
      const countryFieldDef = fieldData?.conditional_fields?.Others?.[0];

      return (
        <React.Fragment key={fieldId}>
        <Col xs={24} sm={12} md={8}>
          {!isOthersSelected ? (
            <Form.Item label={fieldData.label} name={"64"} rules={rules}>
              <Select
                showSearch
                allowClear
                className="input-box"
                placeholder={fieldData.placeholder}
                value={formData[64] || ""}
                onChange={(val) => {
                  if (val === "Others") {
                    setIsOthersSelected(true);
                    handleFormChange("", 64);
                  } else {
                    setIsOthersSelected(false);
                    handleFormChange(val, 64);
                  }
                }}
                optionFilterProp="children"
              >
                {fieldData?.option?.map((opt, idx) => (
                  <Option key={idx} value={opt.value || opt}>
                    {opt.label}
                  </Option>
                ))}
                {String(sessionData?.userType) !== "3" && (
                  <Option value="Others">Others</Option>
                )}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item label={fieldData.label} required>
              <Input
                className="input-box"
                placeholder="Enter Client Customer Name"
                value={formData[64] ?? ""}
                suffix={
                  <span
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontSize: "1rem",
                      marginRight: "4px",
                    }}
                    onClick={() => {
                      setIsOthersSelected(false);
                      handleFormChange("", 64); // reset value
                    }}
                  >
                    x
                  </span>
                }
                onChange={(e) => {
                  const val = e.target.value;
                  handleFormChange(val, 64);
                }}
              />
            </Form.Item>
          )}
        </Col>

        {isOthersSelected && countryFieldDef && (
          <Col xs={24} sm={12} md={8} key={countryFieldDef.id}>
            <Form.Item
              label={countryFieldDef.label}
              name={countryFieldDef.id.toString()}
              rules={[
                {
                  required: countryFieldDef.required,
                  message: `${countryFieldDef.label} is required`,
                },
              ]}
            >
              <Select
                showSearch
                allowClear
                className="input-box"
                placeholder={countryFieldDef.placeholder}
                value={formData[countryFieldDef.id] || undefined}
                onChange={(val) => handleFormChange(val, countryFieldDef.id)}
                optionFilterProp="children"
              >
                {countryFieldDef?.option?.map((opt, idx) =>
                  typeof opt === "string" ? (
                    <Option key={idx} value={opt}>
                      {opt}
                    </Option>
                  ) : (
                    <Option key={idx} value={opt?.value}>
                      {opt?.label}
                    </Option>
                  )
                )}
              </Select>
            </Form.Item>
          </Col>
        )}
        </React.Fragment>
      );
    }

    if (fieldId === 137) {
      return (
        <Col xs={24} sm={12} md={8} key={fieldId}>
          <Form.Item
            label={
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}
              >
                <span>{fieldData.label}</span>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.3rem",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={sameAsCurrent}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setSameAsCurrent(checked);

                      if (checked) {
                        const val138 = formData[138] || "";
                        handleFormChange(val138, 137);
                      } else {
                        handleFormChange("", 137);
                      }
                    }}
                  />
                  <span style={{ color: "red", fontSize: "0.75rem" }}>
                    Same as Current Address
                  </span>
                </label>
              </div>
            }
            name={fieldId.toString()}
            rules={rules}
          >
            <>
              <Input
                className="input-box"
                value={formData[137] || ""}
                placeholder={fieldData.placeholder}
                disabled={sameAsCurrent}
                onChange={(e) => handleFormChange(e.target.value, 137)}
              />
            </>
          </Form.Item>
        </Col>
      );
    }

    return (
      <Col xs={24} sm={12} md={8} key={fieldId}>
        <Form.Item
          label={fieldData.label}
          name={fieldId.toString()}
          rules={rules}
        >
          {fieldData.input_type === "text" ? (
            <Input
              className="input-box"
              value={value || ""}
              placeholder={fieldData.placeholder}
              onChange={(e) => handleFormChange(e.target.value, fieldId)}
            />
          ) : fieldData.input_type === "amount" ? (
            <NumericFormat
              className="input-box"
              placeholder={fieldData.placeholder}
              value={formData[fieldId] || ""}
              thousandSeparator={true}
              thousandsGroupStyle={formData[31] === "INR" ? "lakh" : "thousand"}
              decimalScale={2}
              allowNegative={false}
              customInput={Input}
              valueIsNumericString={true}
              type="text"
              onValueChange={(values) => {
                const raw = values.value;
                handleFormChange(raw, fieldId);
              }}
            />
          ) : fieldData.input_type === "number" ? (
            <Input
              placeholder={fieldData.placeholder}
              type="text"
              inputMode="numeric" // shows numeric keypad on mobile but still text field
              pattern="[0-9+\- ]*"
              className="input-box"
              value={value || ""}
              onChange={(e) => {
                const v = e.target.value;
                const cleaned = v.replace(/[^0-9+\- ]/g, "");
                handleFormChange(cleaned, fieldId);
              }}
            />
          ) : fieldData.input_type === "alphabet" ? (
            <Input
              placeholder={fieldData.placeholder}
              className="input-box"
              value={value || ""}
              onChange={(e) => {
                const onlyAlphabets = e.target.value.replace(
                  /[^a-zA-Z\s]/g,
                  ""
                );
                handleFormChange(onlyAlphabets, fieldId);
              }}
            />
          ) : fieldData.input_type === "select" ? (
            <Select
              showSearch
              allowClear
              className="input-box"
              placeholder={fieldData.placeholder}
              value={formData[fieldId] || ""}
              onChange={(val) => handleFormChange(val, fieldId)}
              optionFilterProp="children"
            >
              {fieldData?.option?.map((opt, idx) =>
                typeof opt === "string" ? (
                  <Option key={idx} value={opt}>
                    {opt}
                  </Option>
                ) : (
                  <Option key={idx} value={opt?.value}>
                    {opt?.label}
                  </Option>
                )
              )}
            </Select>
          ) : fieldData.input_type === "date" ? (
            <DatePicker
            isClearable
              showIcon
              selected={
                value && !isNaN(new Date(value).getTime())
                  ? new Date(value)
                  : null
              }
              className="input-box"
              onChange={(date) => handleDateChange(date, fieldId)}
              format="YYYY-MM-DD"
              suffixIcon={<FaCalendarAlt />}
              style={{ width: "100%" }}
            />
          ) : fieldData.input_type === "radio" ? (
            <Radio.Group
              value={formData[fieldId]}
              className="input-box"
              onChange={(e) => handleFormChange(e.target.value, fieldId)}
            >
              {fieldData?.option?.map((opt, i) => (
                <Radio key={i} value={opt}>
                  {opt}
                </Radio>
              ))}
            </Radio.Group>
          ) : null}
        </Form.Item>
      </Col>
    );
  };

  const renderSection = (sectionName, sectionData) => {
    const fields = [];

    const renderFieldWithConditionals = (field) => {
      fields.push(renderField(field.id, field));

      const value = formData[field.id];
      if (
        field.conditional_fields &&
        field.conditional_fields[value] &&
        Array.isArray(field.conditional_fields[value])
      ) {
        field.conditional_fields[value].forEach((nestedField) =>
          renderFieldWithConditionals(nestedField)
        );
      }
    };

    sectionData.forEach((field) => renderFieldWithConditionals(field));

    return (
      <div key={sectionName} className="Reviewsection">
        <h3 className="section-title">{sectionName.replace("_", " ")}</h3>
        <Row gutter={[16, 16]}>{fields}</Row>
      </div>
    );
  };

  const renderEEClientChargesSection = () => (
    <div key="ee_client_charges" className="Reviewsection">
      <h3 className="section-title">EE Client Charges</h3>
      <Row gutter={[16, 16]}>
        {EE_CLIENT_CHARGES_FIELDS.map((field) => (
          <Col xs={24} sm={12} md={8} key={field.name}>
            <Form.Item label={field.label} name={field.name}>
              {field.type === "textarea" ? (
                <Input.TextArea
                  className="input-box"
                  rows={3}
                  value={formData[field.name] || ""}
                  onChange={(e) =>
                    setFieldData({ name: field.name, value: e.target.value })
                  }
                />
              ) : field.type === "number" ? (
                <Input
                  className="input-box"
                  type="text"
                  inputMode="decimal"
                  value={formData[field.name] || ""}
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/[^0-9.]/g, "");
                    setFieldData({ name: field.name, value: cleaned });
                  }}
                />
              ) : (
                <Input
                  className="input-box"
                  value={formData[field.name] || ""}
                  onChange={(e) =>
                    setFieldData({ name: field.name, value: e.target.value })
                  }
                />
              )}
            </Form.Item>
          </Col>
        ))}
      </Row>
    </div>
  );

  const handleBackClick = () => {
    Modal.confirm({
      title: "Are you sure?",
      content: "If you go back now, all unsaved data will be lost.",
      okText: "Yes, Go Back",
      okType: "danger",
      cancelText: "Cancel",
      centered: true,
      onOk() {
        navigate("/masterDatabase");
      },
    });
  };

  return (
    <>
      <div className="form-header">
        <button className="back" onClick={() => handleBackClick()}>
          <AiOutlineArrowLeft />
        </button>
        <span style={{ fontWeight: 600 }}>Onboard form</span>
        {/* <span className="progress">Onboarding</span> */}
      </div>
      <hr style={{ color: "#ECEEEB", margin: "0px" }} />

      <Spin
        spinning={loading}
        size="large"
        tip="Loading..."
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          initialValues={formData}
          scrollToFirstError={{ behavior: "smooth", block: "center" }}
        >
          <div
            className="review-container custom-scrollbar"
            style={{ height: "74vh", marginTop: "1.5rem" }}
          >
            {Object.keys(formStructure).map((stepKey) => {
              const stepData = formStructure[stepKey];

              if (!stepData || !Array.isArray(stepData)) {
                return null;
              }

              return stepData.map((sectionData, index) => {
                const sectionName = Object.keys(sectionData)[0];
                return renderSection(sectionName, sectionData[sectionName]);
              });
            })}
            {renderEEClientChargesSection()}
          </div>

          <div className="button-container">
            <Button
              type="primary"
              htmlType="submit"
              shape="round"
              // onClick={() => handleSave()}
              style={{
                backgroundColor: "#4A3AFF",
                padding: "1.2rem",
              }}
            >
              Submit Details
            </Button>
          </div>
        </Form>
      </Spin>
    </>
  );
};

export default OnboardForm;
